import { mapActions, mapGetters, mapState } from 'vuex';
import appMainNav from '@/components/app/app-main-nav/app-main-nav.vue';
import accountVerifyMixin from '@/mixins/accountVerify';
import socialLevelMixin from '@/mixins/socialLevel';
import unreadNotificationMixin from '@/mixins/unreadNotification';
import { MODALS } from '@/components/app/app-modals/app-modals';
import notificationsWidget from '@/components/notifications-widget/notifications-widget.vue';
import appHeaderNotification from '@/components/app/app-header-notification/app-header-notification.vue';
import appSecondaryNav from '@/components/app/app-secondary-nav/app-secondary-nav.vue';

const BALANCE_THRESHOLD = 0;
const DONT_SHOW_LOGIN_AND_SIGN_UP_BUTTONS_ROUTES = [
  'account-page-login',
  'account-page-register',
  'account-password-forgotten',
  'index1',
  'index2',
];

export default {
  mixins: [
    accountVerifyMixin,
    socialLevelMixin,
    unreadNotificationMixin,
  ],
  components: {
    appMainNav,
    notificationsWidget,
    appHeaderNotification,
    appSecondaryNav,
  },
  data() {
    return {
      MODALS,
    };
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn', 'isUserRestricted']),
    ...mapGetters('browse', ['areUserBrowseHeadersEmpty']),
    ...mapState('wallet', ['balance']),
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop', 'isShutdownModeOn']),
    ...mapState('profile', ['settings']),
    ...mapState('notifications', ['showNotificationsWidget']),
    showLoginAndSignUpButtons() {
      return !DONT_SHOW_LOGIN_AND_SIGN_UP_BUTTONS_ROUTES.includes(this.$route.name);
    },
    showSocialAvatarDesktop() {
      return false;
      // return this.isLoggedIn && this.isLayoutDesktop;
    },
    headerPrimaryMenuModifiers() {
      return {
        'header-old-primary__menu-nav': true,
        'header-old-primary__menu-nav--with-avatar-and-notifications': this.showSocialAvatarDesktop,
      };
    },
    showBalanceHeader() {
      return (this.settings.display) ? this.settings.display.ShowBalanceHeader : true;
    },
    notifyOnLowBalance() {
      return this.balance.accountBalanceDecimal <= BALANCE_THRESHOLD;
    },
    valueClassModifiers() {
      const value = this.balance.accountBalanceDecimal;
      return {
        'header-old-primary__menu-item--plus': (!this.notifyOnLowBalance && value > 0),
        'header-old-primary__menu-item--neutral': (!this.notifyOnLowBalance && (typeof value === 'undefined' || value === 0)),
        'header-old-primary__menu-item--minus': (this.notifyOnLowBalance || value < 0),
      };
    },
    isNotificationIconActive() {
      return this.$route.name === 'notifications' || this.showNotificationsWidget;
    },
    showUnreadNotificationCount() {
      return !this.isNotificationIconActive && this.userUnreadNotificationsCountHeader > 0;
    },
    notificationsIconModifiers() {
      return {
        'header-old-primary__menu-notifications': true,
        'header-old-primary__menu-notifications--unread': this.showUnreadNotificationCount,
        'header-old-primary__menu-notifications--mobile': this.isLayoutMobile,
        'header-old-primary__menu-notifications--active': this.isNotificationIconActive,
      };
    },
    depositIconModifiers() {
      const disabled = this.$route.name === 'wallet';
      return {
        'header-old-primary__menu-item--deposit': true,
        'header-old-primary__menu-item--deposit-disabled': disabled,
      };
    },
    depositTitleModifiers() {
      const disabled = this.$route.name === 'wallet';
      return {
        'header-old-primary__menu-item__title': true,
        'header-old-primary__menu-item__title--deposit': true,
        'header-old-primary__menu-item__title--deposit-disabled': disabled,
      };
    },
  },
  watch: {
    showNotificationsWidget(value) {
      if (!value) {
        this.clearAllNotifications();
      }
    },
  },
  methods: {
    ...mapActions('notifications', ['toggleNotificationsWidget']),
    ...mapActions('search', ['toggleSearchBar']),
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('user', ['logout']),
    onCashClick() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(MODALS.ACCOUNT_ENABLE_CLASSIC);
        return;
      } else if (!this.isUserVerified) {
        this.setCurrentPopup(MODALS.ACCOUNT_VERIFY);
        return;
      }
      this.$router.push({ name: 'wallet' });
    },
    onSignUp() {
      this.setCurrentPopup(MODALS.REGISTER);
    },
    openDepositPopup() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(MODALS.ACCOUNT_ENABLE_CLASSIC);
      } else if (this.isUserVerified) {
        if (this.$route.name !== 'wallet') {
          this.setCurrentPopup(MODALS.ADD_FUNDS);
        }
      } else {
        this.setCurrentPopup(MODALS.ACCOUNT_VERIFY);
      }
    },
    onAvatarClick() {
      this.$router.push({ name: 'portfolio' });
    },
    onLogoClick() {
      if (this.$router.currentRoute.name === 'home') {
        window.location.reload();
      } else {
        window.location.href = '/';
      }
    },
    onNotificationsClick() {
      if (this.isLayoutDesktop && this.$route.name !== 'notifications') {
        this.toggleNotificationsWidget();
      } else if (this.isLayoutMobile && this.$route.name === 'notifications') {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: 'notifications' });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-header/app-header.js